<template>
  <popover-right v-model="isShowRule" width='820px' :closed="cancel" :completeClose="cancel">
    <h1 class="popover-right-title">新建客户跟进规则</h1>
    <el-form class="pover-right-con c-bussiness-follow-rules" :model="info" :rules="rules" ref="bussFollowRule">
      <div class="form-list-info">
        <div class="base-col">
          <div class="item">
            <span class="label">任务名称：</span>
            <el-form-item prop="title " class="lebel-con follow-input">
              <el-input v-model="info.title" type="textarea" :placeholder="`请输入备注，20字以内`" maxlength="20" :autosize="{ minRows: 2}" :show-word-limit="true"></el-input>
            </el-form-item>
          </div>
          <div class="item">
            <span class="label label-required">业务流程：</span>
            <el-form-item prop="type" class="lebel-con follow-input" >
              <el-select v-model="info.type" placeholder="请选择业务流程" @change="changeProcess" :disabled="type === 'edit'">
                <el-option v-for="(opt, key) in options" :key="key" :value="opt.id" :label="opt.name" :disabled="opt.disabled"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item">
            <span class="label label-required">提醒时间：</span>
            <el-form-item prop="time" class="lebel-con follow-input">
              <el-time-select v-model="info.time" placeholder="请选择提醒时间" :picker-options="pickerOptions"></el-time-select>
            </el-form-item>
          </div>
          <div class="item">
            <div class="rule-times">当客户在【
              <span class="labels">{{info.name || '--'}}</span>
              】后
              <el-form-item prop="value" class="lebel-con follow-input">
                <el-input type="number" v-model.trim="info.value" class="days" />
                <p class="ru-desc">天后需要再次跟进</p>
              </el-form-item>
            </div>
          </div>
          <div class="item">
            <span class="label"></span>
            <div class="lebel-con">
              <div class="custom-btn btn-submit">
                <el-button type="primary" @click="save">提交</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </popover-right>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import {configKeys} from '@/setting/index';
import {setFollowRule} from '@/api/system';
export default {
  name: 'OperateFollowRule',
  components: {
    PopoverRight
  },
  data () {
    const validateDays = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入天数'));
      } else if (!/^[1-9]{1,3}$/.test(value)) {
        callback(new Error('天数为1-999的数字类型'));
      } else {
        callback();
      }
    }
    return {
      isShowRule: false,
      type: '',
      info: {
        time: '09:00',
        name: '',
        type: '',
        value: ''
      },
      rules: {
        type: [
          {required: true, message: '请选择业务流程', trigger: 'change'}
        ],
        time: [
          {required: true, message: '请选择提醒时间', trigger: 'change'}
        ],
        value: [
          {validator: validateDays, trigger: 'blur'}
        ]
      },
      options: {},
      pickerOptions: {
        start: '00:00',
        end: '24:00',
        step: '01:00'
      },
    }
  },
  async mounted () {
    const res = await this.$store.dispatch('initConfig', [configKeys.task_settings]);
    this.optionsList = res['task_settings'];
  },
  methods: {
    open (data, type, hasList = []) {
      this.type = type;
      this.options = Object.keys(this.optionsList).map(v => {
        const isExit = hasList.findIndex(m => m.type === v) >= 0;
        return {
          id: v,
          name: this.optionsList[v],
          disabled: isExit
        }
      })
      if (type === 'edit') {
        this.info = Object.assign({}, this.info, data);
      }
      this.isShowRule = true;
    },
    cancel () {
      this.isShowRule = false;
      this.info= {
        time: '09:00',
        name: '',
        type: '',
        value: ''
      }
      this.options = [];
      this.$nextTick(() => {
        this.$refs.bussFollowRule && this.$refs.bussFollowRule.clearValidate();
      })
    },
    changeProcess () {
      const item = this.options.find(v => v.id === this.info.type);
      this.$set(this.info, 'name', item.name);
    },
    save () {
      this.$refs.bussFollowRule && this.$refs.bussFollowRule.validate(async valid => {
        if (!valid) return null;
        try {
          await setFollowRule(this.info);
          this.cancel();
          this.$emit('callback');
          this.$message.success('添加成功');
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      })
    }
  }
}
</script>
<style lang="less">
.c-bussiness-follow-rules .rule-times{
  font-size: 14px;
  color: #333;
  .box(center, start);
  .days{
    width: 70px !important;
    margin: 0 10px;
    display: inline-block;
    vertical-align: middle;
    *{
      height: 32px;
      line-height: 32px;
      padding: 0 0 0 10px;
    }
  }
  .el-form-item__error{
    margin-left: 10px;
  }
  .labels{
    color: #25A0FF;
  }
  .ru-desc{
    display: inline-block;
    vertical-align: middle;
  }
}
</style>